<script setup>
import notification from "@/utils/plugins/NotificationService";
import { computed, onMounted, ref } from 'vue';
import { useUiStore } from "@/app/stores/uiStore";



// Services
import VehicleService from '@/api/services/vehicle.service';
import VehicleServiceRequest from '@/api/services/vehicleRequest.service';

// Icons Components
import IconVehicle from '@/components/icons/IconVehicle.vue';

// My Components
import FuelReceiptTable from '@/components/shared/Vehicles/FuelReceiptTable.vue';

// eslint-disable-next-line no-unused-vars
const uiStore = useUiStore();

// eslint-disable-next-line no-undef
const emit = defineEmits(['close', 'finish']);

const selectedVehicle = ref();
const startDate = ref();
const endDate = ref();
const dateAndTimeReturn = ref(new Date());
const incidents = ref('')
const fullTank = ref(false)
const endKm = ref()
const today = ref(new Date());
const adBlueAdded = ref(false)

const vehicleModel = ref();
const vehicleBrand = ref();
const maxSeats = ref();
const totalSeats = ref();

const uploadedTicket = ref(null);
const canReturnTicket = ref(false);
const dialogNotUploaded = ref(false);

const fuelReceiptMediaObjects = ref([]);

const fuelRef = ref(null);
const getFuelType = computed(() => {
    const selectedId = selectedVehicle.value;
    if (!selectedId) return null;
    const vehicle = vehicles.value.find(v => v['@id'] === selectedId);
    if (!vehicle || !vehicle.fuelType) return null;
    const found = fuelTypeOptions.value.find(
        opt => opt.value === vehicle.fuelType
    );

    return found ? found.label : null;
});
const fuelTypeOptions = ref([
    { label: 'Diesel', value: 'diesel' },
    { label: 'Gasolina', value: 'gasoline' },
    { label: 'Eléctrico', value: 'electric' },
    { label: 'Híbrido', value: 'hybrid' },
    { label: 'Híbrido enchufable', value: 'plugin_hybrid' },
]);


// eslint-disable-next-line no-undef
const props = defineProps({
    vehicleRequest: Object,
});

// eslint-disable-next-line no-unused-vars
const request = computed(() => {
    return props.vehicleRequest;
})

// eslint-disable-next-line no-unused-vars
const vehicles = ref([])

onMounted(() => {
    today.value.setHours(23, 59, 59, 999)
    getVehicles();
    selectedVehicle.value = request.value?.vehicle['@id'];
    vehicleBrand.value = request.value?.vehicle.brand;
    vehicleModel.value = request.value?.vehicle.model;
    totalSeats.value = request.value?.vehicle.totalSeats;
    maxSeats.value = request.value?.vehicle.maxSeats;
    startDate.value = request.value?.startDate;
    endDate.value = request.value?.endDate;
    if (request.value.startKm) {
        endKm.value = request.value.startKm;
    }
})


// Getter
const getVehicles = () => {
    let params = {
        page: 1,
        itemsPerPage: 9999
    }

    uiStore.startLoading();
    VehicleService.getVehicles(params)
        .then((res) => {
            vehicles.value = res.data['hydra:member']
            // uiStore.setLoading(false);
            uiStore.stopLoading();
        })
        .catch(() => {
            Notification.addNotification('Error al intentar eliminar el empleado seleccionado.', 'error', 6000);
            // uiStore.setLoading(false);
            uiStore.stopLoading();
        })
}

const closeDialog = () => {
    emit('close');
}

const cancelDialog = () => {
    removeAllTickets();
    fuelReceiptMediaObjects.value = [];
    closeDialog();
}

const returnRequest = async () => {
    await resetErrors();
    await validate();
    if (Object.values(errors.value).some(Boolean)) {
        return;
    }
    if (uploadedTicket.value && !canReturnTicket.value) {
        dialogNotUploaded.value = true;
        return;
    }

    let params = {
        closedAt: dateAndTimeReturn.value,
        incidents: incidents.value,
        endKm: endKm.value,
        fullTank: fullTank.value,
        fuelReceiptMediaObjects: fuelReceiptMediaObjects.value,
    }

    if (request.value.vehicle.needsAdBlue) {
        params.adBlueAdded = adBlueAdded.value;
    }
    const res = await VehicleServiceRequest.returnVehicleRequest(request.value.id, params)
    if (res && (res.status === 201 || res.status === 200)) {
        notification.addNotification({
            type: 'success',
            message: 'Se ha marcado como devuelto correctamente',
            duration: 6000
        })
        emit('finish');
        emit('close');
    }
    canReturnTicket.value = false;
    // emit('finish')
    // emit('close')
}

// Validate
const resetErrors = () => {
    Object.keys(errors.value).forEach(key => {
        errors.value[key] = false
    })
}

const errors = ref({
    vehicle: false,
    startDate: false,
    endDate: false,
})

const validate = async () => {
    if (!selectedVehicle.value) errors.value.vehicle = true;
    if (!dateAndTimeReturn.value) errors.value.startDate = true;
}

// Tickets (Adjuntar archivos y costes)
const removeAllTickets = () => {
    if (fuelRef.value) {
        fuelRef.value.removeAllTickets();
    }

}

defineExpose({ removeAllTickets })

const addTicket = (ticket) => {
    fuelReceiptMediaObjects.value = ticket;
}

const removeTicket = (ticket) => {
    fuelReceiptMediaObjects.value = ticket;
}


// Dialog not uploaded Ticket
const closeDialogWarningTicketNotUploaded = () => {
    dialogNotUploaded.value = false;
}

const handleReturn = () => {
    closeDialogWarningTicketNotUploaded();
    notification.addNotification({
        type: 'info',
        message: 'Se ha cancelado la devolución.',
        duration: 3000
    })
};

const handleReturnAnyway = () => {
    closeDialogWarningTicketNotUploaded();
    canReturnTicket.value = true;
    returnRequest();
};
</script>

<template>
    <div class="vehicle-return-dialog">
        <div class="my-header">
            <div class="title-text ml-4">
                <IconVehicle class="iconVehicle" />
                Devolver vehículo
            </div>
            <img class="close-icon pointer justify-content-end" src="@/assets/images/aspa_blue_small_entrada.png" alt=""
                @click="cancelDialog()">
        </div>
        <div class="row d-flex dialog-content">
            <div class="col-12 row d-flex mb-3">
                <div class="col-md-6 el-col-xs-24">
                    <label class="w-100" for="car">Coche:</label>
                    <el-select v-model="selectedVehicle" filterable placeholder="Seleccione un coche" id="car" disabled
                        @change="errors.vehicle = false">
                        <el-option v-for="stat in vehicles" :key="stat.id" :label="stat.displayName"
                            :value="stat['@id']">
                        </el-option>
                    </el-select>
                    <small v-if="errors.vehicle" class="invalid-feedback mb-0">
                        Tienes que elegir un coche
                    </small>
                </div>
                <div class="col-md-6 el-col-xs-24">
                    <label class="w-100" for="licensePlate">Matrícula:</label>
                    <el-select v-model="selectedVehicle" filterable placeholder="Seleccione un coche" id="licensePlate"
                        disabled>
                        <el-option v-for="stat in vehicles" :key="stat.id" :label="stat.licensePlate"
                            :value="stat['@id']">
                        </el-option>
                    </el-select>
                </div>
                <div class="col-md-6 el-col-xs-24 mt-2" v-if="vehicleBrand">
                    <label class="w-100">Marca:</label>
                    <el-input v-model="vehicleBrand" disabled>
                    </el-input>
                </div>
                <div class="col-md-6 el-col-xs-24 mt-2" v-if="vehicleModel">
                    <label class="w-100">Modelo:</label>
                    <el-input v-model="vehicleModel" disabled>
                    </el-input>
                </div>
                <div class="col-md-6 el-col-xs-24 mt-2" v-if="totalSeats">
                    <label class="w-100">Asientos:</label>
                    <el-input v-model="totalSeats" disabled>
                    </el-input>
                </div>
                <div class="col-md-6 el-col-xs-24 mt-2" v-if="maxSeats">
                    <label class="w-100">Asientos máximos:</label>
                    <el-input v-model="maxSeats" disabled>
                    </el-input>
                </div>
                <div class="col-md-6 el-col-xs-24 mt-2">
                    <label class="w-100">Tipo de combustible:</label>
                    <el-input v-model="getFuelType" disabled>
                    </el-input>
                </div>
                <div class="col-md-6 el-col-xs-24 mt-2">
                    <label class="w-100" for="date">Fecha y hora inicio:</label>
                    <el-date-picker v-model="startDate" type="datetime" format="DD/MM/YYYY HH:mm" class="mb-1 w-100"
                        disabled />
                </div>
                <div class="col-md-6 el-col-xs-24 mt-3">
                    <label class="w-100" for="date">Fecha y hora fin:</label>
                    <el-date-picker v-model="endDate" type="datetime" format="DD/MM/YYYY HH:mm" class="mb-1 w-100"
                        disabled />
                </div>
                <div class="col-md-6 el-col-xs-24 mt-3">
                    <label class="w-100" for="date">Fecha y hora devolución:</label>
                    <el-date-picker v-model="dateAndTimeReturn" type="datetime" placeholder="Desde" id="date"
                        format="DD/MM/YYYY HH:mm" :clearable="false" class="mb-1 w-100"
                        :picker-options="{ firstDayOfWeek: 1 }" />
                    <small v-if="errors.startDate" class="invalid-feedback mb-0">
                        Tienes que rellenar correctamente este campo
                    </small>
                </div>
                <div class="col-md-12 el-col-xd-24 mt-3">
                    <label class="w-100" for="incidents">Incidente:</label>
                    <textarea v-model="incidents" label="'Incidentes'" id="incidents" rows="3"
                        :placeholder="'Incidencias de la devolución'" class="w-100 p-2">
                        </textarea>
                </div>
                <div class="col-md-6 el-col-xs-24 mt-2">
                    <label class="w-100" for="Kms">Kilómetros finales:</label>
                    <el-input-number v-model="endKm" :min="request.startKm" :step="1.00" :precision="2" id="Kms" class="w-100"
                        placeholder="Kms finales" />
                </div>
                <div class="col-md-4 el-col-xs-24 mt-2">
                    <label class="w-100" for="tank">¿Deposito lleno?</label>
                    <el-switch v-model="fullTank" id="tank" active-text="Sí" inactive-text="No"
                        style="margin-left: 10px;" />
                </div>
                <div class="col-md-6 el-col-xs-24 mt-2" v-if="request.vehicle.needsAdBlue">
                    <label class="w-100" for="tank">¿Se ha añadido AdBlue al vehículo?</label>
                    <el-switch v-model="adBlueAdded" id="tank" active-text="Sí" inactive-text="No"
                        style="margin-left: 10px;" />
                </div>

            </div>
            <!-- Tickets -->
            <div class="col-12 row d-flex mb-3">
                <FuelReceiptTable ref="fuelRef" :request="request" :isReturning="true" @addFile="addTicket"
                    v-model:selectedFile="uploadedTicket" @removeFile="removeTicket" />
            </div>
            <div class="row mt-4">
                <div class="col d-flex justify-content-end gap-3 dialog-actions">
                    <button class="btn btn_yellow px-4 dialog-action-button" @click="cancelDialog()">
                        Cancelar
                    </button>

                    <button class="btn btn_red px-4 dialog-action-button" @click="returnRequest()">
                        Devolver
                    </button>
                </div>
            </div>
        </div>
        <el-dialog v-model="dialogNotUploaded" :center="true" :lock-scroll="true" :show-close="false" :width="750"
            @close="closeDialogWarningTicketNotUploaded()" style="border-radius: 20px; padding: 20px;">
            <template #header>
                <span style="font-size: 20px; font-weight: 600; color: #f56c6c;">⚠ Atención</span>
            </template>

            <div style="font-size: 16px; color: #606266; margin: 20px 0;">
                Hay un ticket que no ha sido subido. ¿Deseas devolverlo igualmente o volver para subirlo?
            </div>

            <template #footer>
                <el-button @click="handleReturn" type="default">Volver</el-button>
                <el-button @click="handleReturnAnyway" type="primary"
                    style="background-color:#f56c6c; border-color:#f56c6c;">Devolver igualmente</el-button>
            </template>
        </el-dialog>
    </div>

</template>

<style scoped lang="scss">
:deep(.el-input.is-disabled .el-input__wrapper),
:deep(.el-select__wrapper.is-disabled) {
    background-color: var(--el-fill-color-light);
}

.my-header {
    margin-top: 2px;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
}


.text-header {
    text-align: left;
    font-size: 4em;
    font-weight: 900;
    letter-spacing: -0.05em;
    color: #f9156f;
    margin-left: 30px;
    margin-top: -7px;
}

.iconVehicle {
    width: 40px;
    fill: $bg-blue;
}

::v-deep(.el-input-number__increase) {
    border-top-right-radius: 20px;
    border-bottom-right-radius: 20px;
}

::v-deep(.el-input-number__decrease) {
    border-top-left-radius: 20px;
    border-bottom-left-radius: 20px;
}

:deep(.el-select__wrapper.is-disabled .el-select__selected-item),
:deep(.el-select__wrapper.is-disabled .el-select__caret),
:deep(.el-select__wrapper.is-disabled),
:deep(.el-input.is-disabled .el-input__inner) {
    cursor: default;
    color: rgb(94, 94, 94) !important;
    -webkit-text-fill-color: rgb(94, 94, 94);

}

:deep(.el-select__wrapper.is-disabled .el-select__caret),
:deep(.el-input.is-disabled .el-input__icon),
:deep(.el-input-number.is-disabled .el-input-number__increase),
:deep(.el-input-number.is-disabled .el-input-number__decrease) {
    cursor: default;
}

/* Tabla tickets */
.styled-table {
    width: 100%;
    border-collapse: collapse;
    margin-top: 1rem;
    font-family: Arial, sans-serif;
}

.styled-table td {
    padding: 8px 12px;
    border-bottom: 1px solid #eee;
    vertical-align: middle;
}

.document-name {
    display: flex;
    align-items: center;
    gap: 8px;
    font-weight: 500;
    color: #007bff;
}

.document-name:hover {
    text-decoration: underline;
}

.icon-file {
    font-size: 1.1rem;
    color: #007bff;
}

.cost-cell {
    font-weight: 600;
    color: #2a2a2a;
}

.actions-cell {
    text-align: center;
}

.dialog-content {
    margin: 0;
}

.dialog-actions {
    width: 100%;
}

.dialog-action-button {
    width: 40%;
}

@media (max-width: 767px) {
    .vehicle-return-dialog {
        padding: 0 2px 8px;
    }

    .my-header {
        align-items: flex-start;
        gap: 12px;
    }

    .my-header .title-text {
        margin-left: 0 !important;
        font-size: 26px;
        line-height: 1.15;
    }

    .text-header {
        font-size: 2.4em;
        margin-left: 0;
    }

    .dialog-actions {
        flex-direction: column;
    }

    .dialog-action-button {
        width: 100%;
    }
}
</style>
